import { render, staticRenderFns } from "./kioskAnalytics.vue?vue&type=template&id=0cb47600"
import script from "./kioskAnalytics.vue?vue&type=script&lang=js"
export * from "./kioskAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports